<template>
  <div style="width: 100%">
    <div
      style="
        position: absolute;
        width: 560px;
        height: 280px;
        top: 20px;
        left: 10px;
      "
    >
      <dv-border-box-11
        :title="name"
        :color="['#69bcfc', '#3390cc']"
        backgroundColor="rgba(14,21,49,.5)"
      >
        <div style="padding: 15px 36px">
          <el-button
            type="warning"
            icon="el-icon-d-arrow-left"
            circle
            size="small"
            style="pointer-events: auto"
            @click="$router.push('/industry')"
          />
          <div
            style="
              font-size: 16px;
              color: #9cd9fc;
              line-height: 150%;
              padding: 20px 0 0 0;
            "
          >
            {{ desc }}
          </div>
        </div>
      </dv-border-box-11>
    </div>
  </div>
</template>

<script>
import map from './DetailMap.js'
export default {
  name: 'IndustryDetail',
  data() {
    return {
      name: null, //乡镇的名称
      desc: null, //乡镇的介绍
    }
  },
  mounted() {
    console.log('【↑↑↑】', this.$options.name)
    map.start(this, this.$route.params.id)
  },
  beforeDestroy() {
    console.log('【↓↓↓】', this.$options.name)
    map.destroy()
  },
  methods: {
    setName(val) {
      this.name = val
    },
    setDesc(val) {
      this.desc = val
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/industry/Detail.vue